import React from "react";
import { Colors } from '@capcenter/shared';
import {Dropdown} from 'react-bootstrap';

const Extensions: React.FC<{
		extensions: Array<{title: string, ext: string,}>,
		phoneNumber: string,
		last?: Boolean,
	}> = (props) => {
		
  return (
		<Dropdown alignRight drop={props.last? "up" : "down"}>
		  <Dropdown.Toggle 
		  	id="dropdown-basic" 
		  	
		  	style={{ 
			  	backgroundColor: Colors.primary, 
			  	borderColor: Colors.primary, 
			  	borderRadius: "0 .25rem .25rem 0", 
			  	borderLeft: "2px solid " + Colors.white100,
			  }}>
		    ext.
		  </Dropdown.Toggle>
		
		  <Dropdown.Menu>
		  
		  	{props.extensions.map((extension, i)=>
			  	<Dropdown.Item key={i} href={"tel:" + props.phoneNumber + "," + extension.ext} className="d-flex justify-content-between">
			  		<div style={{paddingRight: 20}}>{extension.title}</div>
			  		<div style={{width: 15, textAlign: "center"}}>{extension.ext}</div>
			  	</Dropdown.Item>
			  )}
		  </Dropdown.Menu>
		</Dropdown>
  );
}

export default Extensions;